import commonService from './common';

const server = commonService.getAxiosInstance();

const update_group_online_hidden = async (group_id, online_hidden) => {
    try {
        const headers = await commonService.getRequestHeaders();
        const response = await server.patch(`/groups/${group_id}/onlineHidden`, {
            online_hidden
        }, {
            headers
        });
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

export default {
    update_group_online_hidden
}
